/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Nav_ServicesInputs */

const ja_playdata_nav_services = /** @type {(inputs: Playdata_Nav_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サービス`)
};

const en_playdata_nav_services = /** @type {(inputs: Playdata_Nav_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Services`)
};

/**
* | output |
* | --- |
* | "Services" |
*
* @param {Playdata_Nav_ServicesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_nav_services = /** @type {((inputs?: Playdata_Nav_ServicesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Nav_ServicesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_nav_services(inputs)
	return en_playdata_nav_services(inputs)
});